module.exports = __webpack_public_path__ + "img/90.04669f2f.jpg";